import { takeEvery, put } from "redux-saga/effects";
import * as actionTypes from "../constants/actionTypes";
import * as actions from "../actions";
import axios from "../services";
import { sessionExpiredMsg } from "../constants/constants";

function* getCountryList(action) {
    try {
        let response = yield axios.get('/country')
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response.status == 200) {
            yield put(actions.getCountryListSuccess(response.data.data));
        }
        else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("ERROR FROM SAGA AUTH", error.message);
    }
}

function* getProvinceList(action) {
    try {
        let response = yield axios.get(`/country/states-of-country/${action.payload}`)
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (response.status == 200) {
            yield put(actions.getProvinceListSuccess(response.data.data));
            yield put(actions.enrollContestCountryChanged(action.payload));
        }
        else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("ERROR FROM SAGA AUTH", error.message);
    }
}

function* getCityList(action) {
    try {
        let response = yield axios.get(`/country/cities-of-state/${action.payload}`)
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (response.status == 200) {
            yield put(actions.getCityListSuccess(response.data.data));
            yield put(actions.enrollContestProvinceChanged(action.payload));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("ERROR FROM SAGA AUTH", error.message);
    }
}

function* getFilterListData(action) {
    try {
        let responseUser = yield axios
            .get("/users")
            .then(async response => response)
            .catch(async error => {
                return error;
            });

        let response = yield axios.get(`/contests/filter-contest-list`)
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        let userContestFilter = responseUser.data.data.userContestFilter != undefined ? responseUser.data.data.userContestFilter : '';
        if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (response.status == 200) {
            yield put(actions.getFilterListDataSuccess({ contestList: response.data.data, userContestFilter, userConutry: responseUser.data.data.locationInfo.country }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("ERROR FROM SAGA AUTH", error.message);
    }
}

function* updateMediaViewCount(action) {
    try {
        let response = yield axios.post(`users/post-view-count`, {
            contestName: decodeURIComponent(action.payload.contestName),
            mediaId: action.payload.mediaId,
            userId: action.payload.userId
        })
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (response.status == 200) {
            if (action.payload.from == "contestDetail") {
                yield put(actions.updateMediaViewCountSuccess(action.payload));
            } else if (action.payload.from == "singleMedia") {
                yield put(actions.updateSingleMediaCountSuccess(action.payload));
            } else if (action.payload.from == "explore") {
                yield put(actions.updateMediaViewCountExploreSuccess(action.payload));
            } else if (action.payload.from == "savedPosts") {
                yield put(actions.updateMediaViewCountSavedPostsSuccess(action.payload));
            } else if (action.payload.from == "contestProfile") {
                yield put(actions.updateMediaViewCountContestProfileSuccess(action.payload));
            }
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("ERROR FROM SAGA AUTH", error.message);
    }
}

export default function* rootsaga() {
    yield takeEvery(actionTypes.COUNTRY_LIST, getCountryList);
    yield takeEvery(actionTypes.PROVINCE_LIST, getProvinceList);
    yield takeEvery(actionTypes.CITY_LIST, getCityList);
    yield takeEvery(actionTypes.GET_FILTER_LIST_DATA, getFilterListData);
    yield takeEvery(actionTypes.UPDATE_MEDIA_VIEW_COUNT, updateMediaViewCount);
}
